module.exports = __webpack_public_path__ + "img/car.c07d1d54.png";